module.exports = __webpack_public_path__ + "static/media/error.7c395f53.png";